const LOGO_URL = "/logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="border-t border-[#262626] bg-[#0A0A0A] py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & tagline */}
          <div>
            <img src={LOGO_URL} alt="Sammamish Auto Detail" className="h-16 w-auto mb-4" />
            <p className="text-sm text-[#737373] leading-relaxed">
              Premium auto detailing services in Sammamish, Washington. Precision. Protection. Perfection.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4">Quick Links</p>
            <div className="space-y-3">
              {["About", "Services", "Why Us", "Contact"].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(`#${link.toLowerCase().replace(/\s+/g, '-')}`)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="block text-sm text-[#A3A3A3] hover:text-white transition-colors duration-300"
                  data-testid={`footer-link-${link.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link}
                </a>
              ))}
            </div>
          </div>

          {/* Contact info */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4">Contact</p>
            <div className="space-y-3 text-sm text-[#A3A3A3]">
              <p>Sammamish, WA</p>
              <p>(000) 000-0000</p>
              <p>sammamishautodetail@gmail.com</p>
              <p>Mon - Sun: 8AM - 10PM</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-[#262626] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#737373]">
            &copy; {currentYear} Sammamish Auto Detail. All rights reserved.
          </p>
          <p className="text-xs text-[#737373]">
            Proudly serving Sammamish & the Eastside
          </p>
        </div>
      </div>
    </footer>
  );
}
